import { render, staticRenderFns } from "./majorInfoPath.vue?vue&type=template&id=4ccbe862&scoped=true"
import script from "./majorInfoPath.vue?vue&type=script&lang=js"
export * from "./majorInfoPath.vue?vue&type=script&lang=js"
import style0 from "./majorInfoPath.vue?vue&type=style&index=0&id=4ccbe862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccbe862",
  null
  
)

export default component.exports